import {createSelector} from "@ngrx/store";

export const currentPlanDetailSelector = createSelector(
  (appstate:any)=>appstate.state.currentPlanDetail,
  (planDetails)=>planDetails)
